import React, { Component } from "react";
import { connect } from "react-redux";
import queryString from "query-string";
import { Card, Avatar, Image, Tag, Divider } from "antd";
import VideoPlayer from "react-video-js-player";

import { API_BASE } from "../../utils/contrains";
import { req_list_ccw_search_one } from "../../api";
import "./object-work.css";
const { Meta } = Card;
class ObjectWork extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    loading: false,
    item: {},
    seletedKey: "NONE",
  };

  UNSAFE_componentWillMount() {
    const parsed = queryString.parse(window.location.search);
    const { id } = parsed;

    if (id) {
      // 取得
      //console.log(id)
      this.api_single_item(id);
    } else {
      this.setState({ seletedKey: "NONE" });
    }
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_single_item = async (id) => {
    this.setState({ loading: true });
    const item = await req_list_ccw_search_one(id);
    console.log(item);
    if (item !== null) {
      this.setState({ item: item, loading: false, seletedKey: id });
    } else {
      this.setState({ seletedKey: "NONE", loading: false });
    }
  };

  // 數據配置設定 //////////////////////////////////////////////
  style_switch_text_tag(name, value) {
    let ans = "其他";

    switch (name) {
      case "LICENSE":
        switch (value) {
          case "BOTH":
            ans = "無限制";
            break;
          case "BYNCSA":
            ans = "非商業性分享";
            break;
          case "COPYRIGHT":
            ans = "版權所有";
            break;
          default:
            // OTHER
            break;
        }
        return ans;
      case "TYPE":
        switch (value) {
          case "OTHER":
            ans = "其它";
            break;
          case "2D":
            ans = "平面";
            break;
          case "3D":
            ans = "立體";
            break;
          default:
            // OTHER
            break;
        }
        return ans;
      case "ORIGINAL":
        switch (value) {
          case "BOTH":
            ans = "其它";
            break;
          case "NO":
            ans = "非原創";
            break;
          case "YES":
            ans = "原創";
            break;
          default:
            // OTHER
            break;
        }
        return ans;
      case "PUBLIC":
        switch (value) {
          case "NO":
            ans = "關閉瀏覽";
            break;
          case "YES":
            ans = "開放瀏覽";
            break;
          default:
            // OTHER
            break;
        }
        return ans;
      default:
        // OTHER
        break;
    }
  }

  style_switch_color_tag(name, value) {
    let ans = "#87d068";
    switch (name) {
      case "LICENSE":
        switch (value) {
          case "BOTH":
            ans = "olive";
            break;
          case "BYNCSA":
            ans = "sienna";
            break;
          case "COPYRIGHT":
            ans = "goldenRod";
            break;
          default:
            // OTHER
            break;
        }
        return ans;
      case "TYPE":
        switch (value) {
          case "OTHER":
            ans = "magenta";
            break;
          case "2D":
            ans = "darkSlateBlue";
            break;
          case "3D":
            ans = "indigo";
            break;
          default:
            // OTHER
            break;
        }
        return ans;
      case "ORIGINAL":
        switch (value) {
          case "BOTH":
            ans = "plum";
            break;
          case "NO":
            ans = "steelBlue";
            break;
          case "YES":
            ans = "darkOrange";
            break;
          default:
            // OTHER
            break;
        }
        return ans;
      case "PUBLIC":
        switch (value) {
          case "NO":
            ans = "dimGray";
            break;
          case "YES":
            ans = "green";
            break;
          default:
            // OTHER
            break;
        }
        return ans;
      default:
        // OTHER
        break;
    }
  }

  ////////////////////////////////////////////////////////////
  render() {
    const { seletedKey, item } = this.state;
    const {
      IsPublic,
      ObjectType,
      IsOriginality,
      CategoryName,
      ObjectCollectionName,
      ObjectImageFilePath,
      ObjectVideoFilePath,
      CreativeCommonsLicense,
      ObjectCollectionDescription,
      KeywordA,
      KeywordB,
      KeywordC,
      TotalSeenTotal,
      TotalLikeTotal,
      TotalTagTotal,
      TotalDiscussTotal,
    } = item;
    const title = (
      <>
        <Divider orientation="right">
          <Tag color="#f50">
            <i className="fas fa-desktop"></i> {CategoryName}
          </Tag>
        </Divider>
        名稱：{ObjectCollectionName}
        <div>
          {" "}
          標籤：
          {KeywordA === "" ? (
            ""
          ) : (
            <Tag color="magenta">
              <i className="fas fa-tag"></i> {KeywordA}
            </Tag>
          )}
          {KeywordB === "" ? (
            ""
          ) : (
            <Tag color="magenta">
              <i className="fas fa-tag"></i> {KeywordB}
            </Tag>
          )}
          {KeywordC === "" ? (
            ""
          ) : (
            <Tag color="magenta">
              <i className="fas fa-tag"></i> {KeywordC}
            </Tag>
          )}
        </div>
      </>
    );
    const pngfile =
      ObjectImageFilePath === ""
        ? "https://www.salonlfc.com/wp-content/uploads/2018/01/image-not-found-scaled-1150x647.png"
        : API_BASE + ObjectImageFilePath;
    const mp4file = API_BASE + ObjectVideoFilePath;
    const avatarfile =
      CreativeCommonsLicense === "COPYRIGHT" ? (
        <Avatar
          shape="square"
          size={64}
          src="https://www.inventionpathways.com.au/wp-content/uploads/2017/09/copyright-300x300.png"
        />
      ) : (
        <Avatar
          size={64}
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/CC-BY-NC-SA.svg/512px-CC-BY-NC-SA.svg.png"
        />
      );
    return (
      <div className="flex">
        <div>
          {seletedKey === "NONE" ? (
            <span>無此作品</span>
          ) : (
            <>
              {IsPublic === "YES" ? (
                <Card
                  style={{ width: 470 }}
                  cover={
                    ObjectVideoFilePath === "" ? (
                      <Image
                        src={pngfile}
                        fallback="data:image/png;base64,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"
                      />
                    ) : (
                      <VideoPlayer
                        controls={true}
                        src={mp4file}
                        poster={pngfile}
                        width="470"
                      />
                    )
                  }
                  actions={[
                    <span>
                      <i className="far fa-eye"></i> {TotalSeenTotal}
                    </span>,
                    <span>
                      <i className="far fa-heart"></i> {TotalLikeTotal}
                    </span>,
                    <span>
                      <i className="fas fa-tag"></i> {TotalTagTotal}
                    </span>,
                    <span>
                      <i className="far fa-comment"></i> {TotalDiscussTotal}
                    </span>,
                  ]}
                >
                  <Meta
                    avatar={avatarfile}
                    title={title}
                    description={
                      <span
                        dangerouslySetInnerHTML={{
                          __html: ObjectCollectionDescription,
                        }}
                      />
                    }
                  />
                  <p>
                    <Tag color="default">
                      {this.style_switch_text_tag("PUBLIC", IsPublic)}
                    </Tag>
                    <span>/ </span>
                    <Tag color="default">
                      {this.style_switch_text_tag("TYPE", ObjectType)}
                    </Tag>
                    <span>/ </span>
                    <Tag color="default">
                      {this.style_switch_text_tag("ORIGINAL", IsOriginality)}
                    </Tag>
                    <span>/ </span>
                    <Tag color="default">
                      {this.style_switch_text_tag(
                        "LICENSE",
                        CreativeCommonsLicense
                      )}
                    </Tag>
                  </p>
                </Card>
              ) : (
                <>
                  {" "}
                  <span>該作品不開放檢視</span>
                </>
              )}
            </>
          )}
        </div>
      </div>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(ObjectWork);
